import React from "react";
import "../../Stylesheets/WhatWeDeliver/WhatWeDeliver.scss";
import deliverimg from "../../assests/Images/Whatwedeliver/boxoneimg.png";
import threed from "../../assests/Images/Whatwedeliver/threeD.png";
import medialink from "../../assests/Images/Whatwedeliver/medialink.png";
import producttag from "../../assests/Images/Whatwedeliver/producttag.png";
import drone from "../../assests/Images/Whatwedeliver/drone.png";
import googlemap from "../../assests/Images/Whatwedeliver/googlemap.png";
import floorplan from "../../assests/Images/Whatwedeliver/floorplan.png";
import sensitivedata from "../../assests/Images/Whatwedeliver/sensitivedata.png";

const WhatWeDeliver = () => {
  return (
    <div className="whatwedeliver-main-wrapper" id="deliver">
      <div className="whatwedeliver-inner-wrapper">
        <div className="whatwedeliver-heading">
          <button>
            <span className="our-threesixty">What We </span>
            Deliver ?
          </button>
        </div>

        {/* <div className="whatwedeliver-column-wrap"> */}
          <div className="row whatwedeliver-cont container-fluid">
            <div className="col-md-6 box-one">
            <div className="row">
              <div className="col-12">
              <img src={deliverimg} alt="What we deliver" className="whatweimage"></img>

              </div>
            </div>
            </div>
            <div className="col-md-6 box-two">
              <div className="list-div">
              <ul className="row list-ul">
                  <div className="col-12 list-li">
                    <img src={threed}></img>
                    <span>Immersive 360 Virtual Tour</span>
                  </div>

                  <div className="col-12 list-li">
                    <img src={medialink}></img>
                    <span>Media & Link Integration</span>
                  </div>

                  <div className="col-12 list-li">
                    <img src={producttag}></img>
                    <span>Product/Object Tagging</span>
                  </div>

                  <div className="col-12 list-li">
                    <img src={drone}></img>
                    <span>Drone Panorama</span>
                  </div>

                  <div className="col-12 list-li">
                    <img src={googlemap}></img>
                    <span>Google Map Integration</span>
                  </div>

                  <div className="col-12 list-li">
                    <img src={floorplan}></img>
                    <span>Floorplan</span>
                  </div>

                  <div className="col-12 list-li">
                    <img src={sensitivedata}></img>
                    <span>Sensitive Data Blurring</span>
                  </div>
                </ul>
                {/* <ul className="list-ul">
                  <li className="list-li">
                    <img src={threed}></img>
                    <span>Immersive 360 Virtual Tour</span>
                  </li>

                  <li className="list-li">
                    <img src={medialink}></img>
                    <span>Media & Link Integration</span>
                  </li>

                  <li className="list-li">
                    <img src={producttag}></img>
                    <span>Product/Object Tagging</span>
                  </li>

                  <li className="list-li">
                    <img src={drone}></img>
                    <span>Drone Panorama</span>
                  </li>

                  <li className="list-li">
                    <img src={googlemap}></img>
                    <span>Google Map Integration</span>
                  </li>

                  <li className="list-li">
                    <img src={floorplan}></img>
                    <span>Floorplan</span>
                  </li>

                  <li className="list-li">
                    <img src={sensitivedata}></img>
                    <span>Sensitive Data Blurring</span>
                  </li>
                </ul> */}
              </div>
            </div>
          </div>
        {/* </div> */}
      </div>
    </div>
  );
};

export default WhatWeDeliver;
